export default __webpack_public_path__ + "static/media/illustrationCompany.6af5d7ce.svg";